export default "__VITE_ASSET__Do5_5ds4__"